<template>
  <div class="wrapper">
    <main-visual></main-visual>
    <comic></comic>
    <video-section></video-section>
    <twitter></twitter>
    <quiz></quiz>
    <profile></profile>
    <global-footer></global-footer>
  </div>
</template>

<script>
import MainVisual from '@/components/MainVisual'
import Comic from '@/components/comic'
import VideoSection from '@/components/Video'
import Twitter from '@/components/Twitter'
import Quiz from '@/components/Quiz'
import Profile from '@/components/Profile'
import GlobalFooter from '@/components/GlobalFooter'

export default {
  name: 'indexPage',
  components: {
    MainVisual,
    Comic,
    VideoSection,
    Twitter,
    Quiz,
    Profile,
    GlobalFooter
  },

  metaInfo: {
    title: 'とり野菜みそスペシャルサイト | とり野菜みそオンライン：株式会社まつや公式サイト'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Index.vue?617924c8